import { useEffect } from "react";

import type { EventPrefix } from "@/features/analytics/models";
import { EVENT_PREFIX } from "@/features/analytics/models";
import { trackCheckoutInitiated } from "@/features/analytics/trackers";
import { useOnboardingStore } from "@/features/onboarding/stores";
import { useOnboardingUser } from "./";

export const useTrackCheckoutInitiated = ({
  enabled,
  eventPrefix = EVENT_PREFIX.NONE,
}: {
  enabled: boolean;
  eventPrefix?: EventPrefix;
}) => {
  const selectedCategories = useOnboardingStore(
    (state) => state.selectedCategories,
  );

  const user = useOnboardingUser();

  useEffect(() => {
    if (enabled && user) {
      trackCheckoutInitiated({ user, selectedCategories, eventPrefix });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
